import {AvatarMenuItem} from '@coolcolduk/ui-mui';
import {List, ListItem, ListItemText} from '@mui/material';
import NavBarMobileMenuDrawerMenuHeader from './NavBarMobileMenuDrawerMenuHeader';

export interface NavBarMobileMenuDrawerMenuProps {
  navItems: AvatarMenuItem[];
  onCloseMenu: () => void;
}

export default function NavBarMobileMenuDrawerMenu({navItems, onCloseMenu}: NavBarMobileMenuDrawerMenuProps) {
  const handleItemClick = (item: AvatarMenuItem) => {
    // Close the mobile menu first
    onCloseMenu();
    // Then execute the original onClick if it exists
    if (item.onClick) {
      item.onClick();
    }
  };

  return (
    <>
      {/* Mobile Menu Header */}
      <NavBarMobileMenuDrawerMenuHeader />

      {/* Mobile Navigation Items */}
      <List data-testid="navbar-mobile-menu-drawer-menu-list" sx={{mb: 3}}>
        {navItems.map((item, index) => (
          <ListItem
            key={typeof item.label === 'string' ? item.label : item.label?.toString()}
            data-testid={`navbar-mobile-menu-drawer-menu-list-item-${typeof item.label === 'string' ? item.label?.toLowerCase().replace(' ', '-') : index}`}
            component="a"
            onClick={() => handleItemClick(item)}
            sx={{
              borderRadius: '8px',
              mb: 1,
              '&:hover': {
                backgroundColor: 'grey.100',
              },
            }}
          >
            <ListItemText
              primary={item.label}
              sx={{
                '& .MuiListItemText-primary': {
                  fontWeight: 500,
                  color: 'text.primary',
                },
              }}
            />
          </ListItem>
        ))}
      </List>
    </>
  );
}
